export const GET_CALL_NOTIFICATIONS_REQUEST = "GET_CALL_NOTIFICATIONS_REQUEST";
export const GET_CALL_NOTIFICATIONS_SUCCESS = "GET_CALL_NOTIFICATIONS_SUCCESS";
export const GET_CALL_NOTIFICATIONS_FAILURE = "GET_CALL_NOTIFICATIONS_FAILURE";
